import { createContext, useContext } from 'react';

interface HoneyMoonContextType {
  data: Omit<ViagemDataType, 'destinos' | 'category'>;
}

const HoneyMoonContext = createContext<HoneyMoonContextType>({} as HoneyMoonContextType);

export const useHoneyMoonContext = () => {
  return useContext(HoneyMoonContext);
};

export default HoneyMoonContext;
